import Vue from 'vue';
import { PropValidator } from 'vue/types/options';

/**
 * Mixin para aplicar tema `dark` o `light` a un componente.
 */
export default Vue.extend({
    inject: ['theme'],
    props: {
        /** Usar estilo dark */
        dark: { type: Boolean, default: null } as PropValidator<boolean | null>,
        /** Usar estilo light */
        light: { type: Boolean, default: null } as PropValidator<boolean | null>
    },
    computed: {
        /**
         * Indica si el componente es dark.
         * Esto puede ocurrir porque su prop `dark` es `true` o porque el tema global es dark.
         */
        isDark(): boolean {
            if (this.dark === true) {
                // explicitly dark
                return true;
            } else if (this.light === true) {
                // explicitly light
                return false;
            } else {
                // inherit from parent, or default false if there is none
                return (this as any).theme.isDark;
            }
        },
        themeClasses(): object {
            return {
                'theme--dark': this.isDark,
                'theme--light': !this.isDark
            };
        }
    }
});
